import React from 'react';

import { formatMoney } from '@betterment/js-runtime';
import { Box, Text } from '@betterment/samba-react';

import { HighlightRow, Purpose, formatDate } from './HighlightRow';

import { ProjectedBalanceTooltip } from '../ProjectedBalanceTooltip';

export const MajorPurchaseHighlights: React.FC<{ purpose: Purpose<'PurposeMajorPurchase'> }> = ({ purpose }) => {
  const timeSeries = purpose.majorPurchaseProjection?.balanceTimeSeries;
  if (!timeSeries) return null;

  const target = purpose.majorPurchaseTarget;
  const finalPoint = timeSeries?.[timeSeries.length - 1];

  return (
    <>
      <HighlightRow>
        <HighlightRow.Leading>
          <Box css={{ display: 'flex', gap: 'space.50' }}>
            <Text variant="text100">Projected balance</Text>
            <ProjectedBalanceTooltip />
          </Box>
          <Text variant="text50" color="text.weak">
            {formatDate(finalPoint.date)}
          </Text>
        </HighlightRow.Leading>
        <HighlightRow.Trailing>
          <Text variant="text100">{formatMoney(finalPoint.expected)}</Text>
        </HighlightRow.Trailing>
      </HighlightRow>
      {target.amount && (
        <HighlightRow>
          <HighlightRow.Leading>
            <Text variant="text100">Savings target</Text>
            {target.date && (
              <Text variant="text50" color="text.weak">
                {formatDate(target.date)}
              </Text>
            )}
          </HighlightRow.Leading>
          <HighlightRow.Trailing>
            <Text variant="text100">{formatMoney(target.amount)}</Text>
          </HighlightRow.Trailing>
        </HighlightRow>
      )}
    </>
  );
};
